// TODO(dmaretskyi): Use UUID.
//
// Copyright 2024 DXOS.org
//

export const createId = () => Math.random().toString(36).slice(2);
